// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {ImageSrc, Href} from 'docs/markdoc/attribute-types';

export const ImageCard: MarkdocTagRegistration = {
  tag: 'image-card',
  component: 'ImageCard',
  selfClosing: true,
  attributes: {
    badge: {
      type: String,
      required: false,
      localizable: true,
      description: 'A badge to render next to the title',
    },
    text: {
      type: String,
      required: true,
      localizable: true,
      description: 'The body text of the card',
    },
    title: {
      type: String,
      required: true,
      localizable: true,
      description: 'Title of the card',
    },
    href: {
      type: Href,
      required: true,
      description: 'URL that clicking the card will take you to',
    },
    image: {
      type: ImageSrc,
      required: true,
      description:
        'Path to the images for the image displayed at the top of the card',
    },
    product: {
      type: String,
      required: false,
      description: 'The product with which the card is associated',
    },
  },
};
